import { VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { View } from 'native-base';
import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';

import { ScrollCloseToBottomProvider } from '../../contexts/ScrollCloseToBottom';
import { useImpersonate } from '../../hooks/useImpersonate';
import { useScrollCloseToBottom } from '../../hooks/useScrollCloseToBottom';

import { FixedFeeHeader } from './components/FixedFeeHeader';
import { FixedFeeTermsSection } from './components/FixedFeeTermsSection';
import { HasSomeImpersonateWarning } from './components/HasSomeImpersonateWarning';

const styles = StyleSheet.create({
  contentComponentStyle: { flex: 1 },
});

export const FixedFee: React.FC = () => {
  const { hasSomeImpersonation } = useImpersonate();
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { isCloseToBottom, validateIsCloseToBottom } = useScrollCloseToBottom();

  return (
    <ScrollView
      scrollEventThrottle={200}
      onScroll={({ nativeEvent }) => validateIsCloseToBottom(nativeEvent)}
      style={styles.contentComponentStyle}
      showsHorizontalScrollIndicator={false}>
      <ScrollCloseToBottomProvider isCloseToBottom={isCloseToBottom}>
        <View
          p="inset.xs"
          px={{ base: 'inline.xxxs', lg: 'inline.xxs' }}
          flex={1}
          width="full"
          mb={{ base: 'stack.lg', sm: 0 }}
          maxWidth={{ base: '100%', sm: '95%', lg: undefined }}
          minWidth={0}>
          <VStack space={isMobile ? 'stack.xxxs' : 'stack.xxs'} flex={1}>
            {hasSomeImpersonation && <HasSomeImpersonateWarning />}
            <FixedFeeHeader hasSomeImpersonation={hasSomeImpersonation} />
            <FixedFeeTermsSection hasSomeImpersonation={hasSomeImpersonation} />
          </VStack>
        </View>
      </ScrollCloseToBottomProvider>
    </ScrollView>
  );
};
